const config = () => {
    if (process.env.REACT_APP_BUILD_ENV === "production") {
        return {
            appEnv: process.env.REACT_APP_PROD_APP_ENV,
            campaignId: process.env.REACT_APP_PROD_CAMPAIGN_ID,
            authFunc: process.env.REACT_APP_PROD_AUTH_FUNC,
            backendBaseUrl: process.env.REACT_APP_PROD_BACKEND_BASE_URL
        };
    } else if (process.env.REACT_APP_BUILD_ENV === "development") {
        return {
            appEnv: process.env.REACT_APP_DEV_APP_ENV,
            campaignId: process.env.REACT_APP_DEV_CAMPAIGN_ID,
            authFunc: process.env.REACT_APP_DEV_AUTH_FUNC,
            backendBaseUrl: process.env.REACT_APP_DEV_BACKEND_BASE_URL
        };
    } else {
        return {
            appEnv: process.env.REACT_APP_LOCAL_APP_ENV,
            campaignId: process.env.REACT_APP_LOCAL_CAMPAIGN_ID,
            authFunc: process.env.REACT_APP_LOCAL_AUTH_FUNC,
            backendBaseUrl: process.env.REACT_APP_LOCAL_BACKEND_BASE_URL
        };
    }
};

export const Config = config();
